import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import useLanguage from '../../../../../customHooks/useLanguage';
import { getOrdinalNumber } from '../../../../../utils/usefulFunctions';
import IconBaseOccupancy from './iconsRatesByPerson/IconBaseOccupancy';
import IconSingleUse from './iconsRatesByPerson/IconSingleUse';
import IconOtherAdults from './iconsRatesByPerson/IconOtherAdults';

interface AdultInputLabelProps {
    isBaseOccupancy: boolean;
    personNumber: number;
    isSingleUse: boolean;
    standardOccupancy: number;
}

const AdultInputLabel = (props: AdultInputLabelProps) => {
    const { isBaseOccupancy, personNumber, isSingleUse, standardOccupancy } =
        props;
    const translate = useTranslate();
    const language = useLanguage();

    const singleUseTitle = translate('single_use_first');
    const baseOccupancyTitle = `${translate('standard')}`;
    const otherAdultsTitle = `${getOrdinalNumber(
        personNumber,
        language
    )} ${translate('adult')}`;

    return (
        <div className='flex flex-center gap-20 flex-align-end  width100perc'>
            <p className='text-overflow-ellipsis font-weight-600'>
                {isBaseOccupancy
                    ? baseOccupancyTitle
                    : isSingleUse
                    ? singleUseTitle
                    : otherAdultsTitle}
            </p>

            {isBaseOccupancy && (
                <IconBaseOccupancy
                    personNumber={personNumber}
                    standardOccupancy={standardOccupancy}
                />
            )}
            {isSingleUse && <IconSingleUse />}
            {!isBaseOccupancy && !isSingleUse && (
                <IconOtherAdults personNumber={personNumber} />
            )}
        </div>
    );
};

export default AdultInputLabel;
